import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import { formatTireSizeLabel, parseSetAxleSizes } from "../list/tirePairDisplay";

// One line per tire. Sets list the front tire, then the rear tire, each with
// its load index and speed rating ("190/55 R17 75W").
export function cartSizeLines(product) {
  const item = product || {};

  if (item.set) {
    const parsed = parseSetAxleSizes(item.displaySize);
    if (parsed) {
      return [
        {
          key: "front",
          label: "קדמי",
          size: formatTireSizeLabel(parsed.front, item.frontLoad, item.frontSpeed),
        },
        {
          key: "rear",
          label: "אחורי",
          size: formatTireSizeLabel(parsed.rear, item.rearLoad, item.rearSpeed),
        },
      ].filter((line) => line.size);
    }
  }

  const size = formatTireSizeLabel(
    item.displaySize,
    item.load || item.loadIndex,
    item.speed || item.speedIndex
  );
  if (!size) {
    return [];
  }

  return [{ key: "size", label: null, size }];
}

const pill = {
  display: "inline-block",
  padding: "2px 10px",
  borderRadius: 16,
  backgroundColor: "rgba(0, 0, 0, 0.08)",
};

const styles = () => ({
  list: {
    margin: "4px 8px",
  },
  line: {
    display: "block",
    marginTop: 6,
    "&:first-child": {
      marginTop: 0,
    },
  },
  label: {
    ...pill,
    marginRight: 8,
  },
  // Same face as the cart price (.result-item-pricing).
  value: {
    ...pill,
    fontFamily: "'Lato', sans-serif",
    fontWeight: 700,
  },
});

function CartSizeLines({ classes, product }) {
  const lines = cartSizeLines(product);
  if (lines.length === 0) {
    return null;
  }

  return (
    <div className={classes.list} dir="rtl">
      {lines.map((line) => (
        <div key={line.key} className={classes.line}>
          {line.label ? (
            <Typography variant="body2" component="span" className={classes.label}>
              {line.label}
            </Typography>
          ) : null}
          <Typography
            variant="body2"
            component="bdi"
            dir="ltr"
            className={classes.value}
          >
            {line.size}
          </Typography>
        </div>
      ))}
    </div>
  );
}

CartSizeLines.propTypes = {
  classes: PropTypes.object.isRequired,
  product: PropTypes.object,
};

export default withStyles(styles)(CartSizeLines);
